export default {
  namespaced: true,
  state: {
    notifications: [],
    notificationId: 1
  },

  mutations: {
    PUSH_NOTIFICATION(state, notification) {
      state.notifications.push({
        ...notification,
        id: state.notificationId
      });
      state.notificationId++;
    },

    DELETE_NOTIFICATION(state, notificationToRemove) {
      state.notifications = state.notifications.filter(
        notification => notification.id !== notificationToRemove.id
      );
    }
  },

  actions: {
    add({ commit }, notification) {
      commit("PUSH_NOTIFICATION", notification);
    },

    remove({ commit }, notification) {
      commit("DELETE_NOTIFICATION", notification);
    }
  }
};
